import { render, staticRenderFns } from "./PurchaseReturnOrderEdit.vue?vue&type=template&id=1022c140&scoped=true&"
import script from "./PurchaseReturnOrderEdit.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturnOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseReturnOrderEdit.vue?vue&type=style&index=0&id=1022c140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1022c140",
  null
  
)

export default component.exports